import React, { useState } from 'react'
import NavBar from '../../components/navBar/NavBar'
import './login.css'
import {  db } from '../../utitilties/firebase';
import {  useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';

const CenterEmailLogin = () => {

    const navigate = useNavigate()

    const [email, setEmail] = useState('')



    const checkIfCenterEmail = async () => {
        const q = query(collection(db, "PhysioCenters"), where("email", "==", email));

        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            alert('Not Valid Email')
            return
        } else {
            let userId = ''
            let authset = false

            querySnapshot.forEach((doc) => {
                userId = doc.id
                authset = doc.data().isAuthSet
            })
            navigate('/pwd', { state: { userId, email, authset } })
        }
       
    }

    return (
        <>
            <NavBar />
            <div className='login'>
                <div className='login_sub' >
                    <h1>Physio Center Login</h1>

                    <input
                        type="text"
                        className="text_input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                    />


                    <div className="btn"
                        onClick={checkIfCenterEmail}
                    >
                        <p>Next</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CenterEmailLogin